import React from 'react';
import { useForm, usePage } from '@inertiajs/react';
import { Button } from '../../components/ui/button';
import { Checkbox } from '../../components/ui/checkbox';
import { Input } from '../../components/ui/input';
import ValidationError from '../../components/ValidationError';
import { useTrans } from '../../hooks/useTrans';
import ProfileTabs from './components/ProfileTabs';

export default function Index({ user, canImportOrders, pageTranslations }) {
    const translate = useTrans();
    const { routes } = usePage().props;

    const { data, setData, put, processing, errors } = useForm({
        first_name: user.firstName ?? '',
        last_name: user.lastName ?? '',
        phone_number: user.phoneNumber ?? '',
        mobile_number: user.mobileNumber ?? '',
        track_and_trace: user.trackAndTraceUpdates ? true : false,
        information_submit: '1',
    });

    function handleSubmit(e) {
        e.preventDefault();
        put(routes.profileUpdate);
    }

    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <ProfileTabs />
            <div className="rounded-[3px] rounded-tl-none border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    <form onSubmit={handleSubmit}>
                        <h3 className="text-2xl font-bold text-[#003545] mb-4">
                            {translate('Profiel')}
                        </h3>

                        <div className="space-y-4">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="first_name">
                                    {translate('Voornaam')}&nbsp;<sup>*</sup>
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="first_name"
                                        value={data.first_name}
                                        onChange={(e) => setData('first_name', e.target.value)}
                                        required
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.first_name} />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="last_name">
                                    {translate('Achternaam')}&nbsp;<sup>*</sup>
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="last_name"
                                        value={data.last_name}
                                        onChange={(e) => setData('last_name', e.target.value)}
                                        required
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.last_name} />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="phone_number">
                                    {translate('Telefoonnummer')}
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="phone_number"
                                        value={data.phone_number}
                                        onChange={(e) => setData('phone_number', e.target.value)}
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.phone_number} />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <label className="sm:w-[217px] shrink-0 text-sm font-bold text-[#003545] mb-1 sm:mb-0" htmlFor="mobile_number">
                                    {translate('Mobiel')}
                                </label>
                                <div className="w-full sm:w-[352px]">
                                    <Input
                                        id="mobile_number"
                                        value={data.mobile_number}
                                        onChange={(e) => setData('mobile_number', e.target.value)}
                                        className="h-[44px] font-normal"
                                    />
                                    <ValidationError message={errors.mobile_number} />
                                </div>
                            </div>
                        </div>

                        <hr className="my-7 border-[#ddd]" />

                        <h3 className="text-2xl font-bold text-[#003545] mb-4">
                            {pageTranslations.notifications}
                        </h3>

                        <p className="text-sm text-[#003545] mb-4">
                            {canImportOrders
                                ? translate('Wanneer deze instelling is ingeschakeld, wordt voor elke aangemaakte of geïmporteerde order automatisch een e-mail verzonden naar de persoon die de order heeft aangemaakt.')
                                : translate('Wanneer deze instelling is ingeschakeld, wordt voor elke aangemaakte order automatisch een e-mail verzonden naar de persoon die de order heeft aangemaakt.')
                            }
                        </p>

                        <div className="flex items-center gap-2 mb-4">
                            <Checkbox
                                id="track_and_trace"
                                checked={data.track_and_trace}
                                onCheckedChange={(checked) => setData('track_and_trace', checked)}
                            />
                            <label htmlFor="track_and_trace" className="text-sm text-[#003545] cursor-pointer">
                                {pageTranslations.trackAndTrace}
                            </label>
                        </div>

                        <hr className="my-7 border-[#ddd]" />

                        <div className="flex justify-end">
                            <Button variant="primary" type="submit" disabled={processing}>
                                {translate('Opslaan')}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
